import DependenciesInjector from '../../helpers/dependencies-injector';
// import { TrackingController } from './controllers/tracking-controller';
import { interactionController } from './controllers/interaction-controller';

export class TrackingModule {
    constructor() {}

    async initialize () {
        DependenciesInjector.register([
            // { key: 'XRMSDKModule', construct: () => { return import('./../xrmsdk/xrmsdk.module'); }},
            // { key: 'TrackingController', construct: TrackingController },
            { key: 'interactionController', construct: interactionController }, 
        ], this);

        // await DependenciesInjector.getRegistered('XRMSDKModule');
        // await DependenciesInjector.getRegistered('TrackingController');
        await DependenciesInjector.getRegistered('interactionController');
    }


}